import { Injectable } from '@angular/core';
import * as _ from 'underscore';
import { Kollavarsham } from '@otas/utils/custom-components/panchang-calendar/kollavarsham/kollavarsham';
import moment from 'moment';
import { DateService } from 'app/services/date.service';
import { istAddDays, istDayKey, istEpoch, istFormat, istFormatTime, istParts, istStartOfDay } from './ist';
// import { naks, tith } from './panchang.js';
import { PanEventJson } from '@otas/model/panchang/panchangam-json';
import { TITHI, NAKSATRAS } from 'app/app.constants';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class PanchangService {
    weekdaysLookup = [
        { en: 'S', ml: 'ഞായർ', enFull: 'Sunday' },
        { en: 'M', ml: 'തിങ്കൾ', enFull: 'Monday' },
        { en: 'T', ml: 'ചൊവ്വ', enFull: 'Tuesday' },
        { en: 'W', ml: 'ബുധൻ', enFull: 'Wednesday' },
        { en: 'T', ml: 'വ്യാഴം', enFull: 'Thursday' },
        { en: 'F', ml: 'വെള്ളി', enFull: 'Friday' },
        { en: 'S', ml: 'ശനി', enFull: 'Saturday' }
    ];
    monthsLookup = [
        { en: 'January', ml: 'ജനുവരി' },
        { en: 'February', ml: 'ഫെബ്രുവരി' },
        { en: 'March', ml: 'മാർച്ച്‌' },
        { en: 'April', ml: 'ഏപ്രിൽ ' },
        { en: 'May', ml: 'മെയ്‌' },
        { en: 'June', ml: 'ജൂണ്‍' },
        { en: 'July', ml: 'ജൂലൈ' },
        { en: 'August', ml: 'ഓഗസ്റ്റ്‌' },
        { en: 'September', ml: 'സെപ്റ്റംബർ' },
        { en: 'October', ml: 'ഒക്ടോബർ' },
        { en: 'November', ml: 'നവംബർ' },
        { en: 'December', ml: 'ഡിസംബർ' }
    ];

    panchangFor50Year: PanEventJson[] = [];
    alreadyCalculatedDates: any[] = [];
    private kollavarsham = new Kollavarsham();
    todayPanchang: PanEventJson[];
    todayPanchangObs = new BehaviorSubject(null);
    fullDataLoaded = new BehaviorSubject(null);
    pradoshDates: any[];
    private loadStarted = false;
    constructor(private http: HttpClient) {
    }
    /**
     * Fetches the precomputed panchang table (12.5 MB) on first demand instead
     * of at service construction, so app startup and the web portal never pay
     * for it. Idempotent; a failed fetch may be retried on the next call.
     */
    ensureLoaded() {
        if (this.loadStarted) {
            return;
        }
        this.loadStarted = true;
        this.http.get('assets/json/panchang.json').subscribe({
            next: (e: any) => {
                this.pradoshDates = [];
                this.panchangFor50Year = e;
                this.todayPanchang = this.calculatePanchang(new Date(), new Date());
                this.todayPanchangObs.next(this.todayPanchang);
                this.fullDataLoaded.next(e);
            },
            error: () => {
                this.loadStarted = false;
            }
        });
    }
    calculateFullPradosham(e) {
        const panevents = e;

        panevents.forEach((panEvent, i) => {

            this.calculatePradhosham(panEvent)
            if ([29, 14].includes(panevents[i + 1]?.tithi?.id) && [27, 12].includes(panEvent.tithi.id)) {
                const startTime = panEvent.tithi.end;
                const endTime = panevents[i + 1]?.tithi?.start;
                // 16:30 / 18:00 on the IST calendar day of each instant (was host-local).
                const sp = istParts(startTime), ep = istParts(endTime);
                const pradoshStartTime = new Date(istEpoch(sp.year, sp.month, sp.day, 16, 30));
                const pradoshendTime = new Date(istEpoch(ep.year, ep.month, ep.day, 18, 0));
                if (moment(pradoshStartTime).isBetween(startTime, endTime)) {
                    panEvent.pradosham = istFormat(startTime, 'DD-MMMM-YYYY')

                    this.pradoshDates.push(startTime);
                }
                if (moment(pradoshendTime).isBetween(startTime, endTime)) {
                    panEvent.pradosham = istFormat(endTime, 'DD-MMMM-YYYY')
                    this.pradoshDates.push(endTime);

                }

            }
        })
    }

    unique(xs) {
        return xs.filter(function (x, i) {
            return xs.indexOf(x) === i;
        });
    }
    getMonths() {

        return this.monthsLookup;
    }
    getYears() {
        const years = [];
        for (let y = 1950; y < 2051; y++) {
            years.push(y);
        }
        return years;
    }

    getMalayalamMonthNames(month) {
        const malayalamMonthNames = month.days.map((day) => {
            return day.malayalamMonth;
        });
        const uniqueMonths = this.unique(malayalamMonthNames);
        return uniqueMonths.join(' - ');
    }

    getMalayalamYears(month) {
        const malayalamYears = month.days.map((day) => {
            return day.malayalamYear;
        });
        const uniqueYears = this.unique(malayalamYears);
        return uniqueYears.join(' - ');
    }

    getMonth(month: number) {
        return this.monthsLookup[month];
    }

    getMonthNamePrefix(calendarMonthElement) {
        return calendarMonthElement.find('.month-name').text().substr(0, 3);
    }
    calculateDayOfMonth(month: number, year: number) {
        return new Date(year, month + 1, 0).getDate();

    }
    getWeeksOfMonth(month: number, year: number) {
        return _.range(1, this.calculateDayOfMonth(month, year), 7);
    }

    calculateWeeks(selectedMonth: number, selectedYear: number, isCalender = false) {
        const weeks = [];
        const today = new Date();
        const kollavarsham = this.kollavarsham;

        for (let i = 1; i <= this.calculateDayOfMonth(selectedMonth, selectedYear); i++) {
            // cache the day we're looping with — a cell is an IST calendar day
            // (Kerala's day), so anchor it at IST midnight, not host-local.
            const date = new Date(istEpoch(selectedYear, selectedMonth, i)),
                dateParts = istParts(date),
                isToday = istDayKey(today) === istDayKey(date);
            const day: any = {
                isToday: isToday,
                isSelected: false, year: dateParts.year, date: dateParts.day,
                day: dateParts.weekday, month: selectedMonth, mlDetails: null
            };

            // add a new week at the start and when 7 days have been added to previous one
            if (weeks.length === 0 || weeks[weeks.length - 1].length === 7) {
                weeks.push([]);
            }
            // add the empty cells for when 1st of month is not a Sunday
            if (!!isCalender && day.date === 1) {
                const weekdaysIndices = this.weekdaysLookup;
                let emptyCellsCount;
                for (let j = 0; j < weekdaysIndices.length; j++) {
                    const index = weekdaysIndices.indexOf(weekdaysIndices[day.day]);
                    if (day.day !== 0) {
                        emptyCellsCount = index;
                        break;
                    }
                }
                for (let k = 0; k < emptyCellsCount; k++) {
                    weeks[weeks.length - 1].push({

                        isToday: '',
                        isSelected: '', year: '', date: '',
                        day: '', month: ''

                    });
                }
            }

            const todayInMalayalamEra = kollavarsham.fromGregorianDate(date);
            day.mlDetails = {
                mlDate: todayInMalayalamEra.kollavarsham.date,
                mlMasaName: todayInMalayalamEra.kollavarsham.mlMasaName,
                masaName: todayInMalayalamEra.kollavarsham.masaName,
                mlmonth: todayInMalayalamEra.kollavarsham.month,
                mlyear: todayInMalayalamEra.kollavarsham.year,
                naksatra: _.mapObject(todayInMalayalamEra.panchang.Nakshatra, e => e),
                tithi: _.mapObject(todayInMalayalamEra.panchang.Tithi, e => e)
            };
            const td: Date = day.mlDetails.tithi.end,
                ts: Date = day.mlDetails.tithi.start;
            this.verifyMlNakshatras(day.mlDetails.naksatra, date);
            this.verifyTwoNaksatras(day, date, weeks);

            if (istParts(td).month - istParts(ts).month === 1) {
                const nextDay = kollavarsham.fromGregorianDate(new Date(istAddDays(date, 1)));
                day.mlDetails.tithi.end = nextDay.panchang.Tithi.start;
            }
            this.verifyTwoTithis(day, date, weeks);
            this.verifyTithi(day.mlDetails.tithi, date);
            weeks[weeks.length - 1].push(day);
        }
        while (!!isCalender && weeks[weeks.length - 1].length < 7) {

            weeks[weeks.length - 1].push({
                isToday: '',
                isSelected: '', year: '', date: '',
                day: '', month: ''
            });
        }
        if (!!isCalender && weeks.length > 5) {
            weeks[weeks.length - 1].forEach((el, i) => {
                if (!!el.date) {
                    weeks[0][i] = el;
                }
            });
            weeks.splice(5, 1);
        }
        return weeks;
    }
    verifyTwoNaksatras(day, date: Date, weeks, isCalendar = true) {
        const todayInMalayalamEra = this.kollavarsham.fromGregorianDate(date, 0, 0);

        // Next-day 08:45 IST boundary (was host-local — abroad this shifted the
        // two-star carry decision by the browser's UTC offset).
        const np = istParts(istAddDays(date, 1)),
            prevStar = _.mapObject(todayInMalayalamEra.panchang.Nakshatra, e => e),
            nextDay845 = new Date(istEpoch(np.year, np.month, np.day, 8, 45)),
            naksatraEndTime = prevStar.end;

        const isBefore = DateService.isBefore(nextDay845, naksatraEndTime);

        if (isCalendar && prevStar.enMalayalam !== day.mlDetails.naksatra.enMalayalam && isBefore) {
            // The carry targets the PREVIOUS day's cell = the last cell of the
            // last NON-EMPTY week row. When the current day is a Sunday, a
            // fresh empty row was just pushed and the old `: weeks[0]`
            // fallback attached the star to WEEK 0's Saturday instead — the
            // isCalendar sibling of the round-6 !isCalendar weeks[0] bug:
            // Saturdays silently lost their rest-of-day star (owner repro:
            // Aayilyam on 23-Jan-2027) while an early-month Saturday gained a
            // phantom one. Pure display attach — no astronomy touched.
            let week = weeks[weeks.length - 1];
            if (!week.length && weeks.length > 1) {
                week = weeks[weeks.length - 2];
            }

            if (!!week.length && !!week[week.length - 1].mlDetails &&
                week[week.length - 1].mlDetails.naksatra.enMalayalam !== prevStar.enMalayalam) {
                prevStar.isTimeHide = true;
                week[week.length - 1].mlDetails.secondStar = prevStar;
            }
        } else if (!isCalendar && prevStar.enMalayalam !== day.enMalayalam && isBefore) {
            // Carry the bridging star back onto the PREVIOUS day's row: a star
            // that starts on day D and ends before D+1 ~08:45 belongs to day D
            // too (it never becomes any day's label). Guard against the row we
            // actually append to — the old code accidentally checked weeks[0]
            // (a row object has no .length), so the append silently depended
            // on whatever the window's first row was, and a star filter could
            // miss two-star days (owner-reported: Aayilyam 12 vs 14 days).
            const target = weeks.length ? weeks[weeks.length - 1] : null;
            if (target && typeof target.nakshathra === 'string' &&
                !target.nakshathra.includes(prevStar.mlMalayalam)) {
                prevStar.isTimeHide = true;
                target.secondStar = prevStar;
                target.nakshathra += ' ' + prevStar.mlMalayalam;
            }
            if (target && typeof target.enNakshathra === 'string' &&
                !target.enNakshathra.includes(prevStar.enMalayalam)) {
                prevStar.isTimeHide = true;
                target.secondStar = prevStar;
                target.enNakshathra += ' ' + prevStar.enMalayalam;
            }
        }
    }
    verifyTwoTithis(day, date, weeks, isCalendar = true) {
        const todayInMalayalamEra = this.kollavarsham.fromGregorianDate(date, 0, 0);
        // Next-day 19:30 IST boundary (was host-local).
        const np = istParts(istAddDays(date, 1)),
            prevTithi = _.mapObject(todayInMalayalamEra.panchang.Tithi, e => e),
            nextDay730 = new Date(istEpoch(np.year, np.month, np.day, 19, 30)),
            naksatraEndTime = prevTithi.end;
        const isBefore = DateService.isBefore(nextDay730, naksatraEndTime);
        if (isCalendar && prevTithi.enMalayalam !== day.mlDetails.tithi.enMalayalam && isBefore) {
            // Last NON-EMPTY week row (see verifyTwoNaksatras) — this branch
            // had NO fallback at all, so Saturday tithi carries were dropped.
            let week = weeks[weeks.length - 1];
            if (!week.length && weeks.length > 1) {
                week = weeks[weeks.length - 2];
            }
            if (!!week.length && !!week[week.length - 1].mlDetails &&
                week[week.length - 1].mlDetails.tithi.enMalayalam !== prevTithi.enMalayalam) {
                prevTithi.isTimeHide = true;
                week[week.length - 1].mlDetails.secondTithi = prevTithi;
            }
        } else if (!isCalendar && prevTithi.enMalayalam !== day.enMalayalam && isBefore) {
            // Same deterministic carry as verifyTwoNaksatras: guard against the
            // row being appended to (the old weeks[0] guard made the append
            // window-dependent) and fix the `+= +' '` typo that concatenated a
            // literal "NaN" into the Malayalam thithi string.
            const target = weeks.length ? weeks[weeks.length - 1] : null;
            if (target && typeof target.thithi === 'string' &&
                !target.thithi.includes(prevTithi.mlMalayalam)) {
                prevTithi.isTimeHide = true;
                target.secondTithi = prevTithi;
                target.thithi += ' ' + prevTithi.mlMalayalam;
            }
            if (target && typeof target.enThithi === 'string' &&
                !target.enThithi.includes(prevTithi.enMalayalam)) {
                prevTithi.isTimeHide = true;
                target.secondTithi = prevTithi;
                target.enThithi += ' ' + prevTithi.enMalayalam;
            }
        }
    }
    verifyMlNakshatras(nakshatra, currDate: Date) {
        // Next-day 08:45 IST boundary + IST day classification (was host-local).
        const nextDay = istAddDays(currDate, 1);
        const np = istParts(nextDay);
        const time845 = new Date(istEpoch(np.year, np.month, np.day, 8, 45));
        const endDate: Date = nakshatra.end;
        if (DateService.isBefore(endDate, time845) || (istDayKey(endDate) === istDayKey(nextDay) && DateService.isBefore(time845, endDate))) {
            nakshatra.isTimeHide = true;
        }
        return nakshatra;
    }
    verifyTithi(tithi, currDate: Date) {
        // Next-day 07:30 IST boundary + IST day classification (was host-local).
        const nextDay = istAddDays(currDate, 1);
        const np = istParts(nextDay);
        const time730 = new Date(istEpoch(np.year, np.month, np.day, 7, 30));
        const endDate: Date = tithi.end;
        if (DateService.isBefore(endDate, time730) || (istDayKey(endDate) === istDayKey(nextDay) && DateService.isBefore(time730, endDate))) {
            tithi.isTimeHide = true;
        }
        return tithi;
    }

    getPanchangInstance(todayInMalayalamEra, nd, naksatra, tithi, currentdate, td, mldetails) {
        const mlWeekdayName: string = todayInMalayalamEra.kollavarsham.mlWeekdayName;
        const enWeekdayName: string = todayInMalayalamEra.kollavarsham.weekdayName;

        const masaName = todayInMalayalamEra.kollavarsham.mlMasaName;
        const enMasaName = todayInMalayalamEra.kollavarsham.masaName.trim();
        const mlYear: string = todayInMalayalamEra.kollavarsham.year + '-' + masaName + '-' + todayInMalayalamEra.kollavarsham.date;
        const enYear: string = todayInMalayalamEra.kollavarsham.year + '-' + enMasaName + '-' + todayInMalayalamEra.kollavarsham.date;
        // Bracket times are IST wall clock (was host-local moment format).
        naksatra.startAndend = naksatra.isTimeHide ? '' : '(' + istFormatTime(nd) + ')';
        tithi.startAndend = tithi.isTimeHide ? '' : '(' + istFormatTime(td) + ')';
        const naksatraName = naksatra.mlMalayalam + naksatra.startAndend;
        const enNaksatraName = naksatra.enMalayalam + naksatra.startAndend;
        const tithiName = tithi.mlMalayalam + tithi.startAndend;
        const enTithiName = tithi.enMalayalam + tithi.startAndend;
        const panEvent: PanEventJson = new PanEventJson(currentdate * 1, naksatraName, tithiName, mlWeekdayName,
            mlYear, enNaksatraName, enTithiName, enWeekdayName, enYear);
        panEvent.setMlData(todayInMalayalamEra.kollavarsham);
        panEvent.setMalyalamDetails(mldetails);
        return panEvent;
    }
    calculatePanchang(fromDate: Date, toDate: Date) {
        this.ensureLoaded();
        const alreadyCalcPanchang: PanEventJson[] = [];
        const panchang = this.panchangFor50Year.length > this.alreadyCalculatedDates.length ?
            this.panchangFor50Year : this.alreadyCalculatedDates;
        // While the JSON is still downloading, compute just the requested window
        // with the calculator (the isAfter branch below) instead of crashing on
        // an empty table.
        // All boundary decisions and computed row keys live on the IST day
        // grid (row `date` values in panchang.json ARE IST midnights) — a
        // caller-supplied local-midnight Date abroad must not shift them.
        const dateAfter = panchang.length ? new Date(istStartOfDay(panchang[panchang.length - 1].date))
            : new Date(istAddDays(istStartOfDay(fromDate), -1));
        const isAfter = !panchang.length || istDayKey(toDate) > istDayKey(dateAfter);
        const kollavarsham = this.kollavarsham;

        // HEAD: a fromDate earlier than the table's first row (a D-N/PAST
        // booking-day-policy past window) — compute the missing leading days
        // with the Kollavarsham calculator, mirroring the isAfter tail below.
        // No today-guard here: these are deliberately requested past dates.
        if (panchang.length && istDayKey(fromDate) < istDayKey(panchang[0].date)) {
            const firstTableDay = new Date(istStartOfDay(panchang[0].date));
            const headEnd = istDayKey(toDate) < istDayKey(firstTableDay)
                ? new Date(istStartOfDay(toDate))
                : new Date(istAddDays(firstTableDay, -1));
            const headStart = istStartOfDay(fromDate);
            const headDays = this.calculateNoOfDays(new Date(headStart), headEnd);
            for (let i = 0; i <= headDays; i++) {
                const currentdate: any = new Date(istAddDays(headStart, i));
                const todayInMalayalamEra = kollavarsham.fromGregorianDate(currentdate);
                const naksatra = _.mapObject(todayInMalayalamEra.panchang.Nakshatra, e => e);
                const tithi = _.mapObject(todayInMalayalamEra.panchang.Tithi, e => e);
                const nd: Date = naksatra.end;
                const td: Date = tithi.end,
                    ts: Date = tithi.start;
                if (istParts(td).month - istParts(ts).month === 1) {
                    const nextDay = kollavarsham.fromGregorianDate(new Date(istAddDays(currentdate, 1)));
                    tithi.end = nextDay.panchang.Tithi.start;
                }
                const day: any = {};
                day.mlDetails = {
                    mlDate: todayInMalayalamEra.kollavarsham.date,
                    mlMasaName: todayInMalayalamEra.kollavarsham.mlMasaName,
                    masaName: todayInMalayalamEra.kollavarsham.masaName,
                    mlmonth: todayInMalayalamEra.kollavarsham.month,
                    mlyear: todayInMalayalamEra.kollavarsham.year,
                    naksatra: _.mapObject(todayInMalayalamEra.panchang.Nakshatra, e => e),
                    tithi: _.mapObject(todayInMalayalamEra.panchang.Tithi, e => e)
                };
                const panEvent: PanEventJson = this.getPanchangInstance(todayInMalayalamEra, nd, naksatra, tithi, currentdate, td, day.mlDetails);
                this.verifyTwoTithis(tithi, currentdate, alreadyCalcPanchang, false);
                this.verifyTithi(tithi, currentdate);
                this.verifyMlNakshatras(naksatra, currentdate);
                this.verifyTwoNaksatras(naksatra, currentdate, alreadyCalcPanchang, false);
                alreadyCalcPanchang.push(panEvent);
            }
        }

        const fromKey = istDayKey(fromDate), toKey = istDayKey(toDate);
        panchang.forEach((panchangDay) => {
            const panDay = moment(panchangDay.date).toDate();
            const rowKey = istDayKey(panchangDay.date);
            if (fromKey <= rowKey && rowKey <= toKey) {
                const currentdate: any = panDay;
                const todayInMalayalamEra = kollavarsham.fromGregorianDate(currentdate);
                const naksatra = _.mapObject(todayInMalayalamEra.panchang.Nakshatra, e => e);
                const tithi = _.mapObject(todayInMalayalamEra.panchang.Tithi, e => e);
                const nd: Date = naksatra.end;
                const td: Date = tithi.end,
                    ts: Date = tithi.start;

                if (istParts(td).month - istParts(ts).month === 1) {
                    const nextDay = kollavarsham.fromGregorianDate(new Date(istAddDays(currentdate, 1)));
                    tithi.end = nextDay.panchang.Tithi.start;
                }
                this.verifyTwoTithis(tithi, currentdate, alreadyCalcPanchang, false);
                this.verifyTithi(tithi, currentdate);
                this.verifyMlNakshatras(naksatra, currentdate);
                this.verifyTwoNaksatras(naksatra, currentdate, alreadyCalcPanchang, false);
                alreadyCalcPanchang.push(panchangDay);
            }
        });
        if (isAfter) {
            const diffDays = this.calculateNoOfDays(dateAfter, new Date(istStartOfDay(toDate)));
            for (let i = 1; i < diffDays; i++) {
                const currentdate: any = new Date(istAddDays(dateAfter, i));
                const todayInMalayalamEra = kollavarsham.fromGregorianDate(currentdate);
                const naksatra = _.mapObject(todayInMalayalamEra.panchang.Nakshatra, e => e);
                const tithi = _.mapObject(todayInMalayalamEra.panchang.Tithi, e => e);
                const nd: Date = naksatra.end;
                const td: Date = tithi.end,
                    ts: Date = tithi.start;

                if (istParts(td).month - istParts(ts).month === 1) {
                    const nextDay = kollavarsham.fromGregorianDate(new Date(istAddDays(currentdate, 1)));
                    tithi.end = nextDay.panchang.Tithi.start;
                }

                const day: any = {};
                day.mlDetails = {
                    mlDate: todayInMalayalamEra.kollavarsham.date,
                    mlMasaName: todayInMalayalamEra.kollavarsham.mlMasaName,
                    masaName: todayInMalayalamEra.kollavarsham.masaName,
                    mlmonth: todayInMalayalamEra.kollavarsham.month,
                    mlyear: todayInMalayalamEra.kollavarsham.year,
                    naksatra: _.mapObject(todayInMalayalamEra.panchang.Nakshatra, e => e),
                    tithi: _.mapObject(todayInMalayalamEra.panchang.Tithi, e => e)
                };
                const panEvent: PanEventJson = this.getPanchangInstance(todayInMalayalamEra, nd, naksatra, tithi, currentdate, td, day.mlDetails);
                if (istDayKey(currentdate) >= istDayKey(new Date())) {
                    this.verifyTwoTithis(tithi, currentdate, alreadyCalcPanchang, false);
                    this.verifyTithi(tithi, currentdate);
                    this.verifyMlNakshatras(naksatra, currentdate);
                    this.verifyTwoNaksatras(naksatra, currentdate, alreadyCalcPanchang, false);
                    alreadyCalcPanchang.push(panEvent);
                }
            }
            // alreadyCalcPanchang.forEach(d => console.log(moment(d.date).format('DD-MM-YYYY')));
        }
        this.alreadyCalculatedDates = alreadyCalcPanchang;
        return alreadyCalcPanchang;
    }
    filteredDatesForTithiOrStar(count: number, isIgnoreToday, thithiNumber = 1, type = 'tithi') {
        this.ensureLoaded();
        const numOfDates = isIgnoreToday ? count + 1 : count;
        let panchangDates: PanEventJson[] = this.panchangFor50Year.length < this.alreadyCalculatedDates.length ?
            _.map(this.alreadyCalculatedDates, e => e)
            : _.map(this.panchangFor50Year, e => e);
        const field = type === 'tithi' ? 'thithi' : 'nakshathra';
        const array = type === 'tithi' ? TITHI : NAKSATRAS;
        if (!panchangDates.length) {
            this.continousBookingDetails();
            panchangDates = this.panchangFor50Year;
        }
        let filterPanchangDays: PanEventJson[] = _.filter(_.map(panchangDates), (day) => {
            const notInclude = day[field].includes(array[thithiNumber > 0 ? thithiNumber - 1 : 0].en);
            const notInclude2 = day[field].includes(array[thithiNumber > 0 ? thithiNumber - 1 : 0].ml);
            // let is
            return notInclude || notInclude2;

        });
        if (numOfDates > filterPanchangDays.length && !!filterPanchangDays.length) {
            const lastIndex = filterPanchangDays[filterPanchangDays.length - 1];
            // Extension horizon on the IST month grid (was host-local month add).
            const lp = istParts(lastIndex.date);
            const toDate = new Date(istEpoch(lp.year, lp.month + (numOfDates - filterPanchangDays.length), lp.day));
            const fromdate = moment(lastIndex.date).toDate();
            panchangDates = panchangDates.concat(this.calculatePanchang(fromdate, toDate));
            filterPanchangDays = _.filter(_.map(panchangDates), (day) => {
                const notInclude = day[field].includes(array[thithiNumber > 0 ? thithiNumber - 1 : 0].en);
                const notInclude2 = day[field].includes(array[thithiNumber > 0 ? thithiNumber - 1 : 0].ml);
                return notInclude || notInclude2;
            });
            this.alreadyCalculatedDates = panchangDates;
        }
        let dates = filterPanchangDays.slice(0, numOfDates);
        if (isIgnoreToday && filterPanchangDays.length && istDayKey(new Date()) === istDayKey(filterPanchangDays[0].date)) {
            dates = filterPanchangDays.slice(1, numOfDates);
        } else {
            dates = filterPanchangDays.slice(0, isIgnoreToday ? numOfDates - 1 : numOfDates);

        }
        return dates;
    }

    calculateNoOfDays(firstDate: Date, secondDate: Date) {
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
        return diffDays;
    }
    continousBookingDetails() {
        const lang = sessionStorage.getItem('language') === 'malayalam';
        const panchang = [];
        // IST midnights — the table's day grid is Kerala's, on any host.
        const firstDay = new Date(istEpoch(1950, 0, 1));
        const dayAfterOneYear = new Date(istEpoch(2051, 0, 1));
        // const firstDay = new Date(2020, 0, 1);
        // const dayAfterOneYear = new Date(2022, 0, 2);
        const kollavarsham = this.kollavarsham;
        // dayAfterOneYear.setFullYear(new Date().getFullYear() + 30);
        for (let i = 0; i < this.calculateNoOfDays(firstDay, dayAfterOneYear); i++) {
            // DateService.
            const currentdate: any = new Date(istAddDays(firstDay, i));
            const todayInMalayalamEra = kollavarsham.fromGregorianDate(currentdate);
            const naksatra = _.mapObject(todayInMalayalamEra.panchang.Nakshatra, e => e);
            const tithi = _.mapObject(todayInMalayalamEra.panchang.Tithi, e => e);
            const day: any = {};
            day.mlDetails = {
                mlDate: todayInMalayalamEra.kollavarsham.date,
                mlMasaName: todayInMalayalamEra.kollavarsham.mlMasaName,
                masaName: todayInMalayalamEra.kollavarsham.masaName,
                mlmonth: todayInMalayalamEra.kollavarsham.month,
                mlyear: todayInMalayalamEra.kollavarsham.year,
                naksatra: _.mapObject(todayInMalayalamEra.panchang.Nakshatra, e => e),
                tithi: _.mapObject(todayInMalayalamEra.panchang.Tithi, e => e)
            };
            const nd: Date = naksatra.end;
            const td: Date = tithi.end,
                ts: Date = tithi.start;

            if (istParts(td).month - istParts(ts).month === 1) {
                const nextDay = kollavarsham.fromGregorianDate(new Date(istAddDays(currentdate, 1)));
                tithi.end = nextDay.panchang.Tithi.start;
            }


            const panEvent: PanEventJson = this.getPanchangInstance(todayInMalayalamEra, nd, naksatra, tithi, currentdate, td, day.mlDetails);
            panEvent.tithi = tithi;
            panEvent.star = naksatra;

            if (istDayKey(currentdate) >= istDayKey(new Date())) {
                this.verifyTwoTithis(tithi, currentdate, panchang, false);
                this.verifyTithi(tithi, currentdate);
                this.verifyMlNakshatras(naksatra, currentdate);
                this.verifyTwoNaksatras(naksatra, currentdate, panchang, false);
                panchang.push(panEvent);
            }
        }
        this.panchangFor50Year = [];
        this.panchangFor50Year = panchang;


        return panchang;
    }
    calculatePradhosham(panEvent) {
        const tithi = panEvent.tithi;
        const startTime = tithi.start;
        const endTime = tithi.end;
        if ([13, 28].includes(tithi?.id)) {
            // console.log(',tith', tithi)
            // All wall-clock boundaries and day labels on the IST clock (was host-local).
            const sp = istParts(startTime), ep = istParts(endTime);
            const pradoshStartTime430 = moment(new Date(istEpoch(sp.year, sp.month, sp.day, 16, 30)));
            const pradoshStartTime60 = moment(new Date(istEpoch(sp.year, sp.month, sp.day, 20, 45)));
            const pradoshendTime60 = moment(new Date(istEpoch(ep.year, ep.month, ep.day, 20, 45)));
            if (moment(startTime).isBefore(pradoshStartTime430)) {

                panEvent.pradosham = istFormat(startTime, 'DD-MMMM-YYYY')
                this.pradoshDates.push(startTime);
                return;
            }
            // console.log(startTime, endTime, '\n', moment(startTime).isAfter(pradoshStartTime430), moment(startTime).isAfter(pradoshStartTime60));
            if (moment(startTime).isAfter(pradoshStartTime430) && moment(startTime).isBefore(pradoshStartTime60)) {
                if (moment(endTime).isAfter(pradoshendTime60)) {

                    panEvent.pradosham = istFormat(endTime, 'DD-MMMM-YYYY')
                    this.pradoshDates.push(endTime);
                } else {
                    panEvent.pradosham = istFormat(startTime, 'DD-MMMM-YYYY')
                    this.pradoshDates.push(startTime);

                }
                return;
            }
            if (moment(startTime).isAfter(pradoshStartTime430) && moment(startTime).isAfter(pradoshStartTime60)) {
                if (Math.floor((istEpoch(ep.year, ep.month, ep.day, 23, 59)
                    - istEpoch(sp.year, sp.month, sp.day, 0, 0)) / 86400000) > 1) {
                    this.pradoshDates.push(new Date(istAddDays(startTime, 1)));
                    panEvent.pradosham = istFormat(istAddDays(startTime, 1), 'DD-MMMM-YYYY')

                } else {
                    panEvent.pradosham = istFormat(endTime, 'DD-MMMM-YYYY')
                    this.pradoshDates.push(endTime);
                }
                return;
            }


            // if (moment(endTime).isBetween(pradoshStartTime60, pradoshendTime430)) {
            //     // console.log(tithi);
            //     if (moment(endTime).set({ hour: 23, minute: 59 }).diff(moment(startTime).set({ hour: 0, minute: 0 }), 'days') > 1) {
            //         this.pradoshDates.push(moment(startTime).add(1, 'days').toDate());

            //     } else {
            //         this.pradoshDates.push(startTime);
            //     }
            //     return;
            // }
            // if (moment(pradoshendTime).isBetween(startTime, endTime)) {
            //     this.pradoshDates.push(endTime);
            //     return;

            // }
            // if (moment(startTime).isAfter(pradoshStartTime430.toDate()) && moment(endTime).isBefore(pradoshendTime.toDate())) {
            //     console.log('startTime', startTime);
            //     const start730 = moment(startTime).set({ hour: 19, minute: 30 });
            //     if (moment(startTime).isBefore(start730)) {
            //         this.pradoshDates.push(startTime);
            //         return;
            //     } else {
            //         this.pradoshDates.push(endTime);
            //         return;

            //     }

            // }
            // console.log(startTime, endTime, '\n');

        }

    }
}
